<template>
  <v-row class="form-step">
    <v-col>
      <v-form>
        <v-row v-if="form.kpi.likert === 'false' || !form.kpi.likert">
          <v-col cols="12">
            <div style="margin-bottom: 15px">
              <span class="text-muted label">Provide the margins</span>
              <v-tooltip
                style="max-width: 800px; white-space: normal"
                text="The values of the margins must be in ascending or descending order."
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    size="x-small"
                    icon
                    variant="outlined"
                    color="#0d47a1"
                    class="ml-2"
                  >
                    <v-icon color="black" icon="fas fa-info" />
                  </v-btn>
                </template>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="commonMargins"
              color="#0d47a1"
              label="Use common margins for all aggregation levels."
              name="common_margins"
              @change="updateMarginsList"
            ></v-checkbox>

            <div class="margins-level-container" v-if="commonMargins === false">
              <div class="margins-level-prompt label">
                Please select an aggregation level:
              </div>
              <v-row>
                <v-col cols="4">
                  <v-select
                    class="margins-level-select"
                    v-model="selectedLevel"
                    :items="optionsLevels"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12">
            <MarginsInput
              v-for="(item, index) in form.kpi.kpi_margins_attributes"
              :key="`margins_${index}`"
              :value="item"
              :selected-level="selectedLevel"
            >
          </MarginsInput>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="mb-2 label">
            <i>
              Likert scale was selected. There is no need to manually set
              margins.
            </i>
          </v-col>
          <v-divider class="border-opacity-75"></v-divider>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script setup>
import MarginsFunctions from "@/Mixins/MarginsFunctions";
import MarginsDistributionPlot from "@/Shared/MarginsDistributionPlot.vue";
import MarginsInput from "../extra_components/MarginsInput.vue";
import { computed, onMounted, ref } from "vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const selectedLevel = ref("");
const commonMargins = ref(true);

const form = props.modelValue;

const optionsLevels = computed(() => {
  let arr = [];
  const kpiMargins = form.kpi.kpi_margins_attributes;
  for (let i = 0; i < kpiMargins.length; i++)
    if (kpiMargins[i].level) arr.push(kpiMargins[i].level);
  return arr;
});

function updateMarginsList() {
  const margins = form.kpi.kpi_margins_attributes;
  // keep ids that may exist (in edit mode)
  let ids = [];
  for (let i = 0; i < margins.length; i++)
    if (margins[i].id !== undefined) ids.push(margins[i].id);
  if (commonMargins.value) {
    // remove everything from the list
    margins.splice(0, margins.length);

    // add the 'common' level
    margins.push({ level: "common", m0: null, m1: null, m2: null, m3: null });
    selectedLevel.value = "common";
  } else {
    // if the user unchecks common reveal add margins per aggregation
    margins.splice(0, margins.length);

    const levels = form.aggregationLevels;
    for (let i = 0; i < levels.length; i++)
      margins.push({
        level: levels[i].name,
        m0: null,
        m1: null,
        m2: null,
        m3: null,
      });

    selectedLevel.value = levels[0].name;
  }

  // add the _destroy keys for previously existing margins
  for (let i = 0; i < ids.length; i++)
    margins.push({ id: ids[i], _destroy: 1 });
}

onMounted(() => {
  const marginsAttrs = form.kpi.kpi_margins_attributes;
  if (marginsAttrs.length > 0) {
    if (marginsAttrs.findIndex((e) => e.level === "common") > -1) {
      commonMargins.value = true;
    }
    selectedLevel.value = marginsAttrs[0].level;
  }
});
</script>

<style scoped>
strong {
  font-size: medium;
}
.label {
  font-size: medium;
}
</style>
